import styled from 'styled-components';
import { THEME } from '@/common/styles/theme';
import { softieCardBase } from '../../shared/softieCardBase.styles';

export const PersonCardSkeleton = styled.div`
	${softieCardBase}
	background: #070509;
	box-shadow: 0 18px 44px rgba(0, 0, 0, 0.42);

	> div:first-child {
		position: absolute;
		inset: 0;
	}

	@media (max-width: ${THEME.mobileBreakpoint}) {
		box-shadow: 0 10px 24px rgba(0, 0, 0, 0.36);
	}
`;

export const PersonCardSkeletonShade = styled.div`
	position: absolute;
	inset: 0;
	background: linear-gradient(
		180deg,
		rgba(0, 0, 0, 0.04) 0%,
		rgba(0, 0, 0, 0.02) 48%,
		rgba(0, 0, 0, 0.76) 100%
	);
	pointer-events: none;
`;

export const PersonCardSkeletonFooter = styled.div`
	position: absolute;
	left: 0;
	right: 0;
	bottom: 0;
	display: grid;
	gap: 8px;
	padding: 0 22px 22px;

	@media (max-width: ${THEME.mobileBreakpoint}) {
		gap: 6px;
		padding: 0 10px 12px;
	}
`;

export const CreateSoftieCardSkeleton = styled.div`
	${softieCardBase}
	display: grid;
	place-content: center;
	justify-items: center;
	gap: 12px;
	border: 1px dashed rgba(255, 151, 242, 0.22);
	background:
		radial-gradient(circle at 50% 42%, rgba(255, 77, 242, 0.08), transparent 38%),
		rgba(12, 5, 17, 0.58);
	box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.04);

	@media (max-width: ${THEME.mobileBreakpoint}) {
		gap: 10px;
	}
`;
